if (!customElements.get('age-gate')) {
  customElements.define(
    'age-gate',
    class AgeGate extends HTMLElement {
      constructor() {
        super();
        this.data = this.querySelector("script[type='application/json']");
        if (!this.data) return;
        this.data = this.data.textContent;
        this.data = JSON.parse(this.data);
        this.requiredAge = this.data.requiredAge;
        this.failureMessageText = this.data.failureMessage;
        this.failureMessageDifference = this.data.failureMessageDifference;

        this.cookieName = 'p80AgeGate';

        this.form = this.querySelector('form');
        this.dayInput = this.querySelector("input[name='age-gate-day']");
        this.monthInput = this.querySelector("input[name='age-gate-month']");
        this.yearInput = this.querySelector("input[name='age-gate-year']");
        this.submit = this.querySelector("button[type='submit']");
        this.failureMessage = this.querySelector('[data-failure-message]');

        this.buttonOver = this.querySelector('.age-gate__button-over');
        this.buttonUnder = this.querySelector('.age-gate__button-under');

        if (
          !this.form ||
          !this.dayInput ||
          !this.monthInput ||
          !this.yearInput ||
          !this.submit ||
          !this.requiredAge ||
          !this.failureMessage ||
          !this.failureMessageText ||
          !this.buttonOver ||
          !this.buttonUnder
        )
          return;

        this.init();
      }

      init() {
        // Our cookie is disabled - don't proceed
        if (this.getCookieData() === 'disable') {
          return;
        }

        this.bind();
        this.show();
      }

      show() {
        this.classList.add('active');
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }

      hide() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this);
      }

      bind() {
        const component = this;
        component.form.addEventListener('submit', function (e) {
          e.preventDefault();
          component.validateAge();
        });
        component.dayInput.addEventListener(
          'keyup',
          debounce((event) => {
            component.day = event.target.value;
            component.validateInputs();
          }, 15).bind(this)
        );
        component.dayInput.addEventListener(
          'change',
          ((event) => {
            component.day = event.target.value;
            component.validateInputs();
          }).bind(this)
        );
        component.monthInput.addEventListener(
          'keyup',
          debounce((event) => {
            component.month = event.target.value;
            component.validateInputs();
          }, 15).bind(this)
        );
        component.monthInput.addEventListener(
          'change',
          ((event) => {
            component.month = event.target.value;
            component.validateInputs();
          }).bind(this)
        );
        component.yearInput.addEventListener(
          'keyup',
          debounce((event) => {
            component.year = event.target.value;
            component.validateInputs();
          }, 150).bind(this)
        );
        component.yearInput.addEventListener(
          'change',
          ((event) => {
            component.year = event.target.value;
            component.validateInputs();
          }).bind(this)
        );

        this.buttonOver.addEventListener('click', () => {
          this.disable();
          this.hide();
        });

        this.buttonUnder.addEventListener('click', () => {
          this.failureMessage.classList.remove('hidden');
        });
      }

      validateInputs() {
        const component = this;
        if (
          component.day &&
          component.day.length == 2 &&
          component.month &&
          component.month.length == 2 &&
          component.year &&
          component.year.length == 4
        ) {
          component.submit.removeAttribute('disabled');
          component.submit.classList.remove('disabled');
        } else {
          component.submit.setAttribute('disabled', true);
          component.submit.classList.add('disabled');
        }
      }

      validateAge() {
        const component = this;
        const dateString = `${component.year}/${component.day}/${component.month}`;
        const birthDate = new Date(dateString);
        const ageDif = Date.now() - birthDate.getTime();
        const ageDate = new Date(ageDif);
        const age = Math.abs(ageDate.getUTCFullYear() - 1970);
        if (age < component.requiredAge) {
          if (component.failureMessageDifference) {
            const difference = component.requiredAge - age;
            component.failureMessage.textContent = '';
            component.failureMessage.textContent =
              component.failureMessageText + ` Come back in ${difference} year(s).`;
          }
          component.failureMessage.classList.remove('hidden');
          return;
        }
        this.disable();
        this.hide();
      }

      getCookieData() {
        const cookies = document.cookie;
        let cookie = cookies.match(new RegExp('(^| )' + this.cookieName + '=([^;]+)'));

        if (!cookie || cookie.length < 2) {
          return null;
        }

        cookie = cookie[2];
        return cookie;
      }

      disable() {
        document.cookie = `${this.cookieName}=disable; expires=${new Date(
          new Date().getTime() + 1000 * 60 * 60 * 24 * 365
        ).toGMTString()}; path=/`;
      }
    }
  );
}
